// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"43581474","833":"221427f0"}[chunkId] + ".chunk.js";
};